import { cn } from '@/design-system/lib/cn';
import { orgInitials } from '@escala/domain/orgs';
import type { Organization } from '@escala/domain/types';

const SIZE = {
  sm: 'size-6.5 rounded-control-sm text-micro',
  md: 'size-7.5 rounded-control-sm text-caption',
  lg: 'size-10 rounded-control text-small',
  xl: 'size-11 rounded-card text-body-lg',
} as const;

/**
 * Marca da organização: as iniciais sobre a cor escolhida para ela (a cor é dado, como a
 * dos ministérios — por isso vem por `style`).
 */
export default function OrgMark({
  org,
  size = 'md',
  className,
}: {
  org: Pick<Organization, 'name' | 'color'>;
  size?: keyof typeof SIZE;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn('grid shrink-0 place-items-center font-bold text-white', SIZE[size], className)}
      style={{ backgroundColor: org.color }}
    >
      {orgInitials(org.name)}
    </span>
  );
}
